export interface UrlParserService {
    parse(url: string): Record<string, unknown> | undefined;
}

export const urlParserService = (): UrlParserService => {
    const parse = (url: string): Record<string, unknown> | undefined => {
        const queryString = url.split("?")[1];

        if (!queryString) {
            return undefined;
        }

        const results = {};

        const params: string[] = queryString.split("&");

        for (const param of params) {
            const item = parseParam(param);
            const key = item.key;
            const value = getValue(item.value);

            if (results[key] && typeof results[key] === "object") {
                results[key] = { ...results[key], ...value };
            } else {
                results[key] = value;
            }
        }

        return results;
    };

    const parseParam = (param: string, objectName?: string) => {
        const keyValue = param.split("=");
        const key = keyValue[0];

        if (key.includes(".")) {
            const objectProperty = key.split(".");
            const name = objectProperty[0];
            const property = objectProperty[1];

            return parseParam(`${property}=${keyValue[1]}`, name);
        }

        if (keyValue.length <= 1) {
            return { key, value: "" };
        }

        const value: string = decodeURIComponent(keyValue[1]);

        return objectName ? { key: objectName, value: { key, value } } : { key, value };
    };

    const getValue = (itemValue: string | Record<string, string>) => {
        if (typeof itemValue === "object") {
            const result = {};

            result[itemValue.key] = getValue(itemValue.value);

            return result;
        }

        return itemValue;
    };

    return { parse };
};
